import { render } from "./AddOrEditQuestionModal.vue?vue&type=template&id=9c08182c"
import script from "./AddOrEditQuestionModal.vue?vue&type=script&lang=js"
export * from "./AddOrEditQuestionModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\mestre\\mestre-do-valor-sn-administrativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__